<template>
    <div class="content">
      <div class="container-fluid">
        <b-row>
        <b-col>
          <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
        </b-col>
      </b-row>
        <div class="row">
          <div class="col-12">
            <card>
              <b-row cols="1" v-if="roles.has('superadmin')">
              <b-col class="my-1">
                <b-form-group
                  label="Outlet"
                  label-for="select-outlet"
                  label-size="sm"
                  class="mb-0"
                >
                <multiselect id="select-outlet" v-model="outlet" :options="outlets" placeholder="Select Outlet" :custom-label="nameWithCode" label="name" track-by="name" @input="getCategory"></multiselect>
                </b-form-group>
              </b-col>
            </b-row>
              <b-row cols="1" cols-md="3" cols-lg="3" class="mb-3">
                <b-col class="my-1">
                  <b-form-group
                    label="Per page"
                    label-for="per-page-select"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </b-col>

                <b-col class="my-1">
                  <b-form-group
                    label="Pagination"
                    label-for="pagination"
                    label-size="sm"
                    class="mb-0"
                  >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="categories"
                    align="fill"
                    size="sm"
                    class="my-0"
                    variant="danger"
                  ></b-pagination>
                  </b-form-group>
                </b-col>

                  <b-col class="my-1">
                  <b-form-group
                    label="Filter"
                    label-for="filter-input"
                    label-size="sm"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Type to Search"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button variant="warning" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                </b-row>

            <b-table
            bordered
            striped
            hover
            responsive
            id="categories"
            :head-variant="headVariant"
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2 d-flex justify-content-center">
                  <b-spinner class="align-middle mr-2"></b-spinner>
                  <strong>Loading...</strong>
                </div>
            </template>

              <template #cell(image)="data">
                        <div class="img-thumb">
                          <div class="img-edit" @click="editImage(data.item.image)" v-b-tooltip.hover.topleft="{ variant: 'success' }"
              title="Change Image"><b-icon icon="pencil" aria-hidden="true"></b-icon></div>
                          <b-img-lazy v-if="data.item.image.thumb"
                            center
                            fluid
                            rounded
                            thumbnail
                            :src="data.item.image.thumb"
                            alt="Thumb"
                          ></b-img-lazy>
                          <b-img-lazy v-else
                            center
                            fluid
                            rounded
                            thumbnail
                            :src="require('@/assets/images/no-image.svg')"
                            alt="Thumb"
                          ></b-img-lazy>
                        </div>
                      </template>
            </b-table>
            <b-row>
              <b-col>
                <p class="text-primary">
                  {{ pageText }}
                </p>
              </b-col>
            </b-row>
            </card>
            <my-upload field="img" @crop-success="cropSuccess" @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail" v-model="show" :width="600" :height="600" :params="params"
        :headers="headers" :lang-ext="en" :noCircle="false" :url="uploadUrl"
        img-format="jpg"></my-upload>
            <div class="row" v-if="this.$dev">
              <div class="col-sm-12">
                {{ this.items.length }}
                </div>
                <pre>Outlet{{ outlet }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from '@/axios';
  import { mapGetters } from "vuex";
  import myUpload from 'vue-image-crop-upload/upload-2.vue';
  import Multiselect from 'vue-multiselect';

    export default {
        components: {
            'my-upload': myUpload,
            'multiselect': Multiselect
        },
      data () {
        return {
          roles: new Set(),
          outletid: '',
          outlet: [],
          outlets: [],
          isBusy: false,
          headVariant: 'dark',
          fields: ['sl_no', 'category_name', 'category_code', 'image'],
          items: [],
          totalRows: '',
          currentPage: 1,
          perPage: 15,
          pageOptions: [5, 10, 15, 25, 50, { value: 100, text: "Show a lot" }],
          filter: null,
          isFilter: false,
          uploadUrl: '',
          show: false,
          params: {
            name: 'cat_image',
            cat_image: '',
            catid: '',
            outletid: '',
          },
          headers: {
            smail: '*_~',
          },
          en: {
          hint: 'Click or drag & drop the file to upload',
          loading: 'Uploading…',
          noSupported: 'Browser is not supported, please use IE10+ or other browsers',
          success: 'Upload success!',
          fail: 'Upload failed!',
          preview: 'Preview',
          btn: {
            off: 'Cancel',
            close: 'Close',
            back: 'Back',
            save: 'Save'
          },
          error: {
            onlyImg: 'Image only',
            outOfSize: 'Image exceeds size limit: ',
            lowestPx: "Image's size is too low. Expected at least: "
          }
        },
        breadcrumb: [
          {
            text: 'Dashboard',
            to: '/admin'
          },
          {
            text: 'Category',
            active: true
          }
        ]
        }
      },
      computed: {
        ...mapGetters(["user"]),
        pageText() {
            if (this.items.length > 0) {
                return `Showing ${Math.ceil(
                    this.currentPage * this.perPage - this.perPage + 1
                )} to
                ${
                    this.items.length > this.perPage
                        ? this.perPage * this.currentPage
                        : this.items.length
                } of ${this.items.length} items (${Math.ceil(
                    this.items.length / this.perPage
                )}
                Pages)`;
            } else {
                return "No Data!";
            }

        },
      },
      created() {
        this.user.roles.forEach((r) => {
        this.roles.add(r.name);
      });
        this.user.outlet.forEach((outlet) => {
        if (outlet) {
          console.log('outlet', outlet);
          this.userHasOutlet = true;
          this.outlet = outlet;
          this.outletid = outlet.outletid;
        }

      });
      let accessToken = localStorage.getItem("token");
      if (accessToken && accessToken !== "") {
          this.headers.Authorization = `Bearer ${accessToken}`;
          // this.headers['Content-Type'] = 'multipart/form-data';
      }
      this.uploadUrl = process.env.NODE_ENV === "development"
            ? "http://localhost:8000/api/v1/outlet/category/update"
            : "https://menu-api.tpdb.in/api/v1/outlet/category/update"

      },
      mounted() {
        this.totalRows = this.items.length
        if (this.roles.has('superadmin')) {
          this.getOutlet();
        } else {
        this.getCategory();
        }
      },
      methods: {
        getCategory() {
          if (this.roles.has('superadmin')) {
          this.outletid = this.outlet.outletid;
        }
          this.isBusy = true;
          axios.post('/outlet/category/getAll',{
            outletid: this.outletid
          }).then((res) => {
            this.isBusy = false;
            let category = res.data.data;
            console.log('category',category);
            let obj = [];
            category.forEach((cat) => {
              let result = {
                sl_no: cat.sl_no,
                category_name: cat.name,
                category_code: cat.catcode,
                image: {
                  catid: cat.catid,
                  catname: cat.name,
                  outletid: cat.outletid,
                  thumb: cat.thumb
                  }
              }
              obj.push(result);
            });
            this.items = obj;
            console.log('items', this.items);
          });
        },
        editImage(image) {
          this.show = !this.show;
          console.log('Image', image);
          this.params.outletid = image.outletid;
          this.params.catname = image.catname;
          this.params.catid = image.catid;
        },
      cropSuccess(imgDataUrl, field) {
        console.log('-------- crop success --------')
        this.imgDataUrl = imgDataUrl
        console.log('Croped img', imgDataUrl);
        console.log('Croped img fields', field);
        this.params.cat_image = imgDataUrl;
        console.log('params', this.params);
      },
      cropUploadSuccess(jsonData, field) {
        console.log('-------- upload success --------')
        console.log('jsonData', jsonData)
        console.log('field: ' + field)
        this.getCategory();
        this.$notifications.notify({
          message: jsonData.message,
            icon: 'nc-icon nc-camera-20',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success'
        });
        setTimeout(() => {
          this.show = false;
        }, 1000);
      },
      cropUploadFail(status, field) {
        console.log('-------- upload fail --------')
        console.log(status)
        console.log('field: ' + field)
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
        this.items.length = filteredItems.length;
        console.log('filteredItems', filteredItems);
        this.isFilter = true;
      },
      getOutlet() {
            axios.get('outlet/getAll').then((res) => {
            console.log('outlets', res.data.data);
            res.data.data.forEach((val) => {
                return this.outlets.push({
                outletid: val.outletid,
                name: val.name,
                outlet_code: val.outlet_code
                })
            });
            console.log('this.outlets', this.outlets);
            });
        },
        nameWithCode ({ name, outlet_code }) {
            return `${name} — [${outlet_code}]`
        },
      },
    }
  </script>
  <style>
    .img-thumb {
      position: relative;
      width: 90px;
      height: 90px;
      transition: all 0.6s ease-in-out;
      z-index: 0;
    }
    .img-thumb img {
      opacity: 1;
    }
    .img-thumb .img-edit {
      position: absolute;
      top: -7px;
      right: -7px;
      width: 30px;
      height: 30px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #ccc;
    }
    .img-thumb:hover > .img-edit, .img-thumb:focus > .img-edit {
      background-color: rgba(0, 0, 0, 0.95);
      transition: all 0.6s ease-in-out;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.8);
    }
    .b-table-busy-slot td {
      width: 100%;
    }
    #categories thead tr {
    border-top: 1px solid #dee2e6;
  }
  </style>
